import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/Dashboard',
      name: 'Home',
      component: () => import('@/containers/DefaultContainer'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/Dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard')
        },
        
        {
          path: '/Profile',
          meta: { label: 'Profile' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Settings/profile')
            },
            {
              path: '/changePassword',
              meta: { label: 'Change Password' },
              name: 'ChangePassword',
              component: () => import('@/views/Settings/changePassword'),
            },
          ]
        },
        {
          path: '/Cases',
          meta: { label: 'Cases' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Incidents/incidents')
            },
            {
              path: ':id/:idset',
              meta: { label: 'Case Details' },
              name: 'Case',
              props:true,
              component: () => import('@/views/Incidents/incident')
            },
            {
              path: '/Similar/:id',
              props: true,
              meta: { label: 'Similar Case Details' },
              name: 'Similar Incident',
              component: () => import('@/views/Incidents/similar')
            },

            {
              path: '/Discussions/:incId',
              meta: { label: 'Discussion Details' },
              name: 'Discussion2',
              props:true,
              component: () => import('@/views/Discussions/chat'),
            },

            {
              path: '/FalseAlarms',
              meta: { label: 'Reported Cases' },
              component: {
                render(c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  component: () => import('@/views/Incidents/falseAlarms')
                },
                {
                  path: ':id/:idset',
                  meta: { label: 'Reported Case Details' },
                  name: 'FalseAlarm',
                  props:true,
                  component: () => import('@/views/Incidents/falseAlarm')
                },
                {
                  path: '/Casedetails/:id',
                  meta: { label: 'Case  Details' },
                  name: 'FalseAlarmincident',
                  props:true,
                  component: () => import('@/views/Incidents/falseAlarmincident')
                },
                {
                  path: '/Userdetails/:id',
                  meta: { label: 'User Details' },
                  name: 'falseAlarmuser',
                  component: () => import('@/views/Incidents/falseAlarmuser'),
                },
                
              ]
            },
            {
              path: '/Watchlist',
              props: true,
              meta: { label: 'Watchlist' },
              name: 'Watchlist',
              component: () => import('@/views/Incidents/watchlist')
            },
            {
              path: '/Map/:id',
              props: true,
              meta: { label: 'Incident Map' },
              name: 'IncidentMap',
              component: () => import('@/views/Incidents/map')
            },
          ]
        },
        {
          path: '/Map',
          meta: { label: 'Map' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Map/map'),
            },
          ]
        },
        {
          path: '/addLocation',
          meta: { label: 'Location' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Map/Location'),
            },
          ]
        },
        {
          path: '/Registration',
          meta: { label: 'Register' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/adminRegistration/superAdminRegistration'),
            },
            {
              path: '/adminRegistration',
              component: () => import('@/views/adminRegistration/adminRegistration'),
            },
          ]
        },
        {
          path: '/Users',
          meta: { label: 'Users' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/users/users'),
            },
            {
              path: ':id/:idset',
              meta: { label: 'User Details' },
              name: 'User',
              component: () => import('@/views/users/user'),
            },
            {
              path: '/addUser',
              meta: { label: 'Add User' },
              name: 'AddUser',
              component: () => import('@/views/users/addUser'),
            },
          ]
        },
        {
          path: '/Admins',
          meta: { label: 'Admins' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Admins/admins'),
            },
            {
              path: ':id',
              meta: { label: 'Admin' },
              name: 'Admin',
              component: () => import('@/views/Admins/admin'),
            },
            {
              path: '/countryAdmin/:id',
              meta: { label: 'Admin' },
              name: 'countryAdmin',
              component: () => import('@/views/Admins/countryAdmin'),
            },
            {
              path: '/stateAdmin/:id',
              meta: { label: 'Admin' },
              name: 'stateAdmin',
              component: () => import('@/views/Admins/stateAdmin'),
            },
            {
              path: '/cityAdmin/:id',
              meta: { label: 'Admin' },
              name: 'cityAdmin',
              component: () => import('@/views/Admins/cityAdmin'),
            },
            {
              path: '/addAdmin',
              meta: { label: 'Add Admin' },
              name: 'Add Admin',
              props:true,
              component: () => import('@/views/Admins/addAdmins'),
            },
          ]
        },
        {
          path: '/Feedbacks',
          meta: { label: 'Feedbacks' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Feedbacks/feedbacks'),
            },
            {
              path: ':id/:idset',
              meta: { label: 'Feedback Details' },
              name: 'Feedback',
              props:true,
              component: () => import('@/views/Feedbacks/feedback'),
            },
          ]
        },
        {
          path: '/Discussions',
          meta: { label: 'Comments' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              
              component: () => import('@/views/Discussions/discussions'),
            },
            {
              path: ':Incid/:commentID/:idset/:idset1',
              meta: { label: 'Comment Details' },
              name: 'Discussion',
              props:true,
              component: () => import('@/views/Discussions/discussion'),
            },
            
          ]
        },
        {
          path: '/Notifications',
          meta: { label: 'Notifications' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Notifications/notifications'),
            },
            {
              path: ':id',
              meta: { label: 'Discussion Details' },
              name: 'Notifications',
              component: () => import('@/views/Notifications/notification'),
            },
          ]
        }
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/pages/Login')
    },
    {
      path: '/superAdminRegister',
      name: 'superRegister',
      component: () => import('../views/adminRegistration/superAdminRegistration')
    },
    {
      path: '/adminRegister',
      name: 'adminRegister',
      component: () => import('../views/adminRegistration/adminRegistration')
    },
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: () => import('../views/pages/Page404'),
      meta: {
        description: 'App 404 Page',
        requiresAuth: false
      }
    },
    {
      path: '/ServerError',
      name: 'ServerError',
      props: true,
      component: () => import('../views/pages/Page500'),
      meta: {
        description: 'App Server Error Page',
        requiresAuth: false
      }
    },

  ]
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token')) {
    axios({
      method: "POST",
      url: "/validate/webtoken",
      headers: {
        "x-auth-token": localStorage.getItem("token")
      }
    })
      .then(response => {
        if (!response.data.status) {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          store.commit("logoutUser");
          // console.log("here after flase!!")
          next({
            name: 'Login'
          })
          return
        }
      })
  }
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({
      name: 'Login'
    })
    return
  }
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({
      path: '/'
    })
    return
  }
  if (from.name === 'adminRegister'  && store.state.isLoggedIn && store.state.register == false ) {
        next({ name: 'adminRegister' })
        return
    }
    if (from.name === 'superRegister'  && store.state.isLoggedIn && store.state.register == false) {
      next({ name: 'superRegister' })
      return
  }
  next()
})

export default router

